import {DELETE_GROWTH_PATH_ERROR, DELETE_GROWTH_PATH_START, DELETE_GROWTH_PATH_SUCCESS} from "../../types";

export default function delete_growth_path(state, action) {
    switch (action.type) {
        case DELETE_GROWTH_PATH_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_GROWTH_PATH_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_GROWTH_PATH_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
